import { alpha } from "@mui/material/styles";

const GREY = {
  0: "#F5EFE6", // Soft off-white (background elements/lighter surface)
  100: "#E4D8C4", // Toasted beige
  200: "#CDBA9C", // Muted sand (secondary text, borders)
  300: "#B29E83", // Dusty mocha (hover backgrounds)
  400: "#927F67", // Soft earthy (separators, disabled text)
  500: "#74624E", // Brown-grey (normal text, icons)
  600: "#574839", // Dark muted brown (stronger text)
  700: "#3D3227", // Espresso (cards, modals)
  800: "#2B241C", // Rich dark (deep backgrounds)
  900: "#18130D", // Almost black brown (dialogs, menus)
  1000: "#0F0D0A", // Black (main dark background)
};

const PRIMARY = {
  lighter: "#FFEDA3", // Slightly softer pale gold (was #FFE9A6)
  light: "#FFD240", // Warm golden yellow (brightened for vibrancy)
  main: "#daba05ff", // Material amber (rich gold base)
  dark: "#D49600", // Deep gold (slightly warmer than #D39E00)
  darker: "#8B6600", // Earthy golden brown (darkened for hover/active)
  contrastText: GREY[100], // Light warm text on gold for accessible contrast
};

const SECONDARY = {
  lighter: "#FFE6B2", // Balanced light amber (slightly warmer)
  light: "#FFAE33", // Medium amber-orange (brighter than #FFB74D)
  main: "#FF9800", // Classic orange (keep)
  dark: "#D97300", // Dark burnt orange (warmer, more saturated)
  darker: "#8A4D00", // Toasted orange (darkened for deep accents)
  contrastText: GREY[100],
};

const INFO = {
  lighter: "#C8E6FF",
  light: "#64B5F6",
  main: "#2196F3",
  dark: "#1976D2",
  darker: "#0D47A1",
  contrastText: "#fff",
};

const SUCCESS = {
  lighter: "#D9F5C9",
  light: "#AED581",
  main: "#7CB342",
  dark: "#558B2F",
  darker: "#33691E",
  contrastText: GREY[100],
};

const WARNING = {
  lighter: "#FFE082",
  light: "#FFCA28",
  main: "#FFB300",
  dark: "#FF8F00",
  darker: "#EF6C00",
  contrastText: GREY[900],
};

const ERROR = {
  lighter: "#FFCDD2",
  light: "#EF5350",
  main: "#F44336",
  dark: "#C62828",
  darker: "#B71C1C",
  contrastText: "#fff",
};

const palette = {
  common: {
    black: GREY[1000],
    white: GREY[0],
  },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.28), // Slightly stronger divider for clarity
  text: {
    primary: GREY[0], // Keep light text on dark background for readability
    secondary: GREY[200], // Muted secondary text
    disabled: GREY[400], // Disabled text
  },
  background: {
    default: GREY[1000], // Deep dark mode background
    paper: GREY[900], // Paper surfaces
    neutral: GREY[800], // Drawer, dialog backgrounds
  },
  action: {
    active: GREY[200],
    hover: alpha(GREY[200], 0.14), // Slightly increased opacity on hover
    selected: alpha(PRIMARY.light, 0.24), // Light golden highlight for selected states
    disabled: alpha(GREY[400], 0.52), // Slightly stronger transparency for disabled
    disabledBackground: alpha(GREY[400], 0.28),
    focus: alpha(PRIMARY.light, 0.32), // Soft golden focus highlight
    hoverOpacity: 0.12,
    disabledOpacity: 0.48,
  },
};

export default palette;
